import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Factory } from 'lucide-react';

const STATS = [
  { value: '7.8 Mt', label: 'Textile Waste/year', percent: '~60%', sub: 'Recycled' },
  { value: '500 Mt', label: 'Crop Residue/year', percent: '~100 Mt (20%)', sub: 'Burnt annually' },
  { value: '~72M tons', label: 'Wastewater/day', percent: '28%', sub: 'Recycled' },
];

const CHALLENGES = [
  {
    num: '1',
    title: 'Growing Waste Mountains',
    text: 'Urban areas generate massive amounts of waste daily. Agricultural residues, textile waste, and other organic materials end up in landfills or are burned, contributing to air pollution and environmental degradation.'
  },
  {
    num: '2',
    title: 'Petrochemical Dependency',
    text: 'Most construction and industrial materials rely on synthetic, non-biodegradable petrochemical-based components that persist in the environment for centuries.'
  },
  {
    num: '3',
    title: 'Critical Recycling Gap',
    text: 'Despite generating 500 Mt of crop residue annually, only 20% finds productive use. The rest is burned or dumped, representing a massive lost opportunity for circular materials.'
  },
];

export const OpportunitySection = () => (
  <section className="py-20 px-6 bg-white">
    <div className="container mx-auto max-w-6xl">
      <div className="text-center mb-12">
        <Badge className="bg-[#E8E3DA] text-[#4A5D4E] border-none mb-4">
          The Opportunity
        </Badge>
        <h2 className="text-4xl font-bold text-[#2C3E2F] mb-4">
          The Urban Waste & Materials Crisis
        </h2>
        <p className="text-lg text-[#5A6B5E] max-w-3xl mx-auto">
          India generates massive amounts of waste daily, yet recycling rates remain critically low
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mb-12">
        {STATS.map((s) => (
          <Card key={s.label} className="border-[#DDD5C7] bg-[#F5F3EE] hover:shadow-lg transition-shadow">
            <CardContent className="p-8 text-center">
              <div className="text-4xl font-bold text-[#D4A574] mb-2">{s.value}</div>
              <div className="text-sm font-semibold text-[#2C3E2F] mb-2">{s.label}</div>
              <div className="text-2xl font-bold text-[#4A5D4E] mb-1">{s.percent}</div>
              <div className="text-xs text-[#5A6B5E]">{s.sub}</div>
            </CardContent>
          </Card>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-12 items-center">
        <div>
          <div className="space-y-6">
            {CHALLENGES.map((c) => (
              <div key={c.num} className="flex gap-4">
                <div className="w-8 h-8 bg-[#D4A574]/20 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-[#D4A574] font-bold">{c.num}</span>
                </div>
                <div>
                  <h4 className="font-semibold text-[#2C3E2F] mb-2">{c.title}</h4>
                  <p className="text-[#5A6B5E]">{c.text}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-8 p-4 bg-[#F5F3EE] rounded-lg">
            <p className="text-xs text-[#5A6B5E]">
              <span className="font-semibold">Sources:</span> Fashion for Good Report 2022, CSE India Report 2024, 
              Ministry of New & Renewable Energy (MNRE), Indian Council for Agricultural Research (ICAR), 
              NITI Aayog Biomass studies, Central Pollution Control Board (CPCB)
            </p>
          </div>
        </div>
        <div>
          <img 
            src="https://images.pexels.com/photos/2768961/pexels-photo-2768961.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" 
            alt="Urban Waste Crisis" 
            className="rounded-2xl shadow-xl"
          />
        </div>
      </div>
    </div>
  </section>
);
